import PaymentStatus from "../../../types/paymentStatus.type";
import { Badge } from "antd";
import {
  paymentStatusColors,
  paymentStatusNames,
} from "../../../utils/paymentStatus.utils";
import { INVOICE_STATUS_NAMES } from "../../../utils/invoiceStatus";
import { OnboardingStatus, VerificationStatus } from "../../../utils/hooks/useWorldCheckVerification.hook";
import {
  onboardingStatus,
  onboardingStatusColors,
  verificationStatus,
  verificationStatusColors,
} from "../../../pages/customers/worldCheckStatus.utils";

export const getStatusOptionLabel = (status: PaymentStatus) => (
  <div style={{ marginTop: "0px" }}>
    <Badge
      color={paymentStatusColors[status]}
      style={{ marginRight: "10px" }}
    />
    {paymentStatusNames[status]}
  </div>
);

export const getInvoiceStatusOptionLabel = (
  status: PaymentStatus
): JSX.Element => (
  <div style={{ marginTop: "0px" }}>
    <Badge
      color={paymentStatusColors[status]}
      style={{ marginRight: "10px" }}
    />
    {INVOICE_STATUS_NAMES[status]}
  </div>
);

export const getWorldcheckVerificationStatusOptionLabel = (
  status: VerificationStatus
) => (
  <div style={{ marginTop: "0px" }}>
    <Badge
      color={verificationStatusColors[status]}
      style={{ marginRight: "10px" }}
    />
    {verificationStatus[status]}
  </div>
);

export const getOnboardingStatusOptionLabel = (
  status: OnboardingStatus
) => (
  <div style={{ marginTop: "0px" }}>
    <Badge
      color={onboardingStatusColors[status]}
      style={{ marginRight: "10px" }}
    />
    {onboardingStatus[status]}
  </div>
);

export const paymentRequestInvoicePayablePossibleMoves = new Map<
  PaymentStatus,
  PaymentStatus[]
>()
  .set(PaymentStatus.DRAFT, [
    PaymentStatus.DRAFT,
    PaymentStatus.PENDING,
    PaymentStatus.APPROVED,
    PaymentStatus.REJECTED,
    PaymentStatus.POSTPONED,
  ])
  .set(PaymentStatus.PENDING, [
    PaymentStatus.PENDING,
    PaymentStatus.APPROVED,
    PaymentStatus.REJECTED,
    PaymentStatus.POSTPONED,
  ])
  .set(PaymentStatus.APPROVED, [PaymentStatus.APPROVED])
  .set(PaymentStatus.PROCESSING, [PaymentStatus.PROCESSING])
  .set(PaymentStatus.COMPLETED, [PaymentStatus.COMPLETED])
  .set(PaymentStatus.CANCELLED, [PaymentStatus.CANCELLED])
  .set(PaymentStatus.FAILED, [PaymentStatus.FAILED])
  .set(PaymentStatus.REJECTED, [PaymentStatus.REJECTED])
  .set(PaymentStatus.POSTPONED, [
    PaymentStatus.POSTPONED,
    PaymentStatus.APPROVED,
  ]);

export const paymentRequestPossibleMoves = new Map<
  PaymentStatus,
  PaymentStatus[]
>()
  .set(PaymentStatus.DRAFT, [
    PaymentStatus.DRAFT,
    PaymentStatus.PENDING,
    PaymentStatus.APPROVED,
    PaymentStatus.REJECTED,
    PaymentStatus.POSTPONED,
  ])
  .set(PaymentStatus.PENDING, [
    PaymentStatus.PENDING,
    PaymentStatus.APPROVED,
    PaymentStatus.REJECTED,
    PaymentStatus.POSTPONED,
  ])
  .set(PaymentStatus.APPROVED, [PaymentStatus.APPROVED])
  .set(PaymentStatus.CANCELLED, [PaymentStatus.CANCELLED])
  .set(PaymentStatus.COMPLETED, [PaymentStatus.COMPLETED])
  .set(PaymentStatus.REJECTED, [PaymentStatus.REJECTED])
  .set(PaymentStatus.PROCESSING, [PaymentStatus.PROCESSING])
  .set(PaymentStatus.FAILED, [PaymentStatus.FAILED])
  .set(PaymentStatus.POSTPONED, [
    PaymentStatus.POSTPONED,
    PaymentStatus.APPROVED,
  ]);

export const paymentOrderInvoiceReceivablePossibleMoves = new Map<
  PaymentStatus,
  PaymentStatus[]
>()
  .set(PaymentStatus.DRAFT, [
    PaymentStatus.DRAFT,
    PaymentStatus.PENDING,
    PaymentStatus.APPROVED,
    PaymentStatus.REJECTED,
    PaymentStatus.POSTPONED,
  ])
  .set(PaymentStatus.PENDING, [
    PaymentStatus.PENDING,
    PaymentStatus.APPROVED,
    PaymentStatus.REJECTED,
    PaymentStatus.POSTPONED,
  ])
  .set(PaymentStatus.APPROVED, [PaymentStatus.APPROVED])
  .set(PaymentStatus.COMPLETED, [PaymentStatus.COMPLETED])
  .set(PaymentStatus.REJECTED, [PaymentStatus.REJECTED])
  .set(PaymentStatus.POSTPONED, [
    PaymentStatus.POSTPONED,
    PaymentStatus.APPROVED,
  ]);

export const createPaymentRequestStatuses = [
  PaymentStatus.DRAFT,
  PaymentStatus.PENDING,
  PaymentStatus.APPROVED,
];

export const createPaymentOrderStatuses = [
  PaymentStatus.DRAFT,
  PaymentStatus.PENDING,
  PaymentStatus.APPROVED,
  PaymentStatus.COMPLETED,
];
